export function serializeDesign(design) {
  if (typeof design === "string") {
    try {
      const decoded = window.atob(design);
      JSON.parse(decodeURIComponent(decoded));
      console.warn("Data is already serialized");
      return design;
    } catch (e) {
      // Not a base64 string
    }
  }
  const asJson = JSON.stringify(design);
  const asSafeString = encodeURIComponent(asJson);
  return window.btoa(asSafeString);
}

export function deserializeDesign(designString) {
  let design = window.atob(designString);
  try {
    design = decodeURIComponent(design);
  } catch (e) {
    console.info("Legacy format detected");
  }
  design = design.replaceAll("abandoned-products", "dynamic-products");
  design = design.replaceAll("viewed-products", "dynamic-products");
  design = design.replaceAll("purchased-products", "dynamic-products");
  design = design.replaceAll("observed-products", "dynamic-products");
  design = design.replaceAll("ABANDONED_PRODUCTS", "DYNAMIC_PRODUCTS");
  design = design.replaceAll("VIEWED_PRODUCTS", "DYNAMIC_PRODUCTS");
  design = design.replaceAll("PURCHASED_PRODUCTS", "DYNAMIC_PRODUCTS");
  design = design.replaceAll("OBSERVED_PRODUCTS", "DYNAMIC_PRODUCTS");
  return JSON.parse(design);
}
